import { type DependencyInitializerFunction } from "@microsoft/applicationinsights-web";

import { insights } from "../insights";
import useUserStore from "~/stores/user";

const addUserToDependency: DependencyInitializerFunction = (envelop) => {
	let user = {
		username: "Anonymous",
		userId: undefined as unknown as string,
		communicationId: undefined as unknown as string,
	};

	const selfUser = useUserStore.getState().getUser();

	if (selfUser) {
		user = {
			username: selfUser.username ?? "Anonymous",
			userId: selfUser.id!,
			communicationId: selfUser.communicationId!,
		};
	}

	if (envelop.properties) {
		envelop.properties.user = user;
	}
};

insights.addDependencyInitializer(addUserToDependency);
